import React, { useEffect } from 'react';

const META_APP_ID = process.env.REACT_APP_META_APP_ID;
const META_CLIENT_TOKEN = process.env.REACT_APP_META_CLIENT_TOKEN;
const REDIRECT_URI = 'https://app.ennoverse.ai/apps/replybot/whatsapp/callback'; // ✅ frontend page, not API

export default function WhatsAppConnect() {
  useEffect(() => {
    console.log("🟢 WhatsApp Connect Page Loaded");
    console.log("🟢 Redirect URI:", REDIRECT_URI);
    
    // Re-parse the DOM in case SDK is already loaded
    if (window.FB && window.FB.XFBML) {
        console.log(window.FB.XFBML);
      window.FB.XFBML.parse();
    } else {
      console.warn("⚠️ FB SDK not available yet.");
    }
  }, []);

  return (
    <div className="p-10">
      <h2 className="text-xl font-bold mb-4">Connect Your WhatsApp</h2>
      <div
        className="fb-whatsapp-signup"
        data-app-id={META_APP_ID}
        data-client-token={META_CLIENT_TOKEN}
        data-redirect-uri={REDIRECT_URI}
        data-state="whatsapp"
        style={{ width: '100%' }}
      ></div>
    </div>
  );
}
